import React from "react";
import Container from "react-bootstrap/Container";
import {Breadcrumb, Col, Row, Table} from "react-bootstrap";
import {Link} from "react-router-dom";

const FAQ = () => {

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <h3>
                            <Breadcrumb>
                                <Breadcrumb.Item active>FAQ</Breadcrumb.Item>
                            </Breadcrumb>
                        </h3>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <h5><strong>Do I have to register to use this site?</strong></h5>
                        <p>
                            No, all of the information on the site is available to everyone, whether you have
                            registered or not.
                        </p>
                        <br/>

                        <h5><strong>Why should I register?</strong></h5>
                        <p>
                            You should register if you are planning to participate in the Porchfest as a performer or a host.
                        </p>
                        <p>
                            If you register as a <strong>performer</strong>, you can add information about your act and you will be able to search
                            for possible venues that fit your preferred time slot and that might be interested in hosting you. If
                            you find a venue that matches your preference, you can contact their owner using
                            the "Contact" button on their venue page and work out the details of performing at their venue.
                        </p>
                        <p>
                            If you register as a <strong>host</strong>, you can add information about your venue and your time slot availability.
                            You'll also be able to search for possible acts that you might be interested in hosting. If
                            you find an act that matches your preference, you can contact their owner using
                            the "Contact" button on their act page and work out the details of hosting them.
                        </p>
                        <p>
                            If you just want to attend Porchfest, you don't have to register.
                        </p>

                        <br/>

                        <h5><strong>How do I register as a performer?</strong></h5>
                        <p>
                            To register as a performer, go to our <Link to="/register" reloadDocument="true">registration</Link> page and select
                            the "register as a Performer" option. This will allow you to login to our site and manage your
                            act.
                        </p>
                        <br/>

                        <h5><strong>How do I register as a host?</strong></h5>
                        <p>
                            To register as a host, go to our <Link to="/register" reloadDocument="true">registration</Link> page and select
                            the "register as a Host" option. This will allow you to login to our site and manage your
                            venue.
                        </p>
                        <br/>

                        <h5><strong>I am a self-hosted performer, how should I register?</strong></h5>
                        <p>
                            If you are a performer that would like to use your own venue, you should select both options
                            of "register as a Host" and "register as a Performer" on our <Link to="/register" reloadDocument="true">registration</Link> page.
                            You can then login to our site, create your venue and act, and schedule the act into one of
                            your available slots, all with a single account.
                        </p>
                        <br/>

                        <h5><strong>I am a performer looking for a host. What should I do?</strong></h5>
                        <p>
                            The Porchfest committee encourages performers and hosts to use the site to schedule each other
                            and agree on the hosting details. As a performer, you can search for hosts on
                            our <Link to="/venues" reloadDocument="true">venues</Link> page,
                            using filters to narrow down the venues by their preferred genres and available time slots.
                        </p>
                        <p>
                            Once you find a venue you like, you can contact its owner by clicking on the "Contact" button
                            on their venue page and filling out the contact form at the bottom to let the owner know you are
                            interested in a match. The venue owner will be notified of your intention to connect and you
                            will be able to continue your conversation with them via email.
                        </p>
                        <br/>

                        <h5><strong>I am a host looking for a performer. What should I do?</strong></h5>
                        <p>
                            The Porchfest committee encourages hosts and performers to use the site to schedule each other
                            and agree on the hosting details. As a host, you can search for performers
                            on our <Link to="/acts" reloadDocument="true">acts</Link> page,
                            using filters to narrow down the acts by their genre, preferred time slot, and status.
                        </p>
                        <p>
                            Once you find an act you like, you can contact its owner by clicking on the "Contact" button
                            on their act page and filling out the contact form at the bottom to let the owner know you are
                            interested in a match. The act owner will be notified of your intention to connect and you will be able to
                            continue your conversation with them via email.
                        </p>
                        <p>
                            After a host and a performer have agreed to match, <strong>it is the host's responsibility to schedule
                            the performer's act into the agreed-upon time slot</strong>. This is performed by the <strong>host</strong> as follows:
                        </p>
                        <ol>
                            <li>Login to the site (if you have not done so already).</li>
                            <li>Select your venue from the <Link to="/myvenues" reloadDocument="true">my venues</Link> page.</li>
                            <li>Click the "Slots / Schedule" button next to the venue name.</li>
                            <li>Select the act you want to schedule for the agreed-upon slot. Note that if you don't see your act,
                                it means they are already scheduled for this slot at another venue.</li>
                            <li>Click the Save button at the bottom of the page.</li>
                        </ol>
                        <br/>

                        <h5><strong>How does a host and performer inform the Porchfest committee about their match?</strong></h5>
                        <p>
                            After a host and a performer have agreed to match (usually after contacting each other via our site),
                            it is the host's responsibility to schedule the performer's act into the agreed-upon time slot
                            in order to indicate to the Porchfest committee that a match has been established. The host can
                            do this by clicking on the "Slots / Schedule" button on their venue page and following the
                            instructions on that page.
                        </p>
                        <p>
                            See the steps above in the "I am a host looking for a performer" section.
                        </p>
                        {/*<ol>*/}
                        {/*    <li>Login to the site (if they have not done so already)</li>*/}
                        {/*    <li>Select your venue from the <Link to="/myvenues" reloadDocument="true">my venues</Link> page</li>*/}
                        {/*    <li>Click the edit button at the bottom of the venue</li>*/}
                        {/*    <li>Select the act you want to schedule for the agreed-upon slot</li>*/}
                        {/*    <li>Click the Save button at the bottom of the page</li>*/}
                        {/*</ol>*/}
                        <p>
                            If you have any trouble performing the match, please <Link to="/contact" reloadDocument="true">contact</Link> us and we will help you.
                        </p>
                        <br/>

                        <h5><strong>What time slots are available for hosting?</strong></h5>
                        <p>
                            We ask each host to provide their availability for one or more of the following 4 time slots:
                        </p>
                        <Table bordered hover size="lg" responsive>
                            <thead className="table table-striped">
                            <tr>
                                <th>Slot</th>
                                <th>Start</th>
                                <th>End</th>
                                <th>Setup</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>1</td>
                                <td>12:00pm</td>
                                <td>1:00pm</td>
                                <td>Setup at 11:30am</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>1:30pm</td>
                                <td>2:30pm</td>
                                <td>Setup at 1:00pm</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>3:00pm</td>
                                <td>4:00pm</td>
                                <td>Setup at 2:30pm</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>4:30pm</td>
                                <td>5:30pm</td>
                                <td>Setup at 4:00pm</td>
                            </tr>
                            </tbody>
                        </Table>
                        <p>
                            If you are a host and you are flexible on the time slot but want to host only one act, you can
                            initially make all the time slots available for your venue. Once you agree with a performer on
                            a slot, you can make the other slots unavailable.
                        </p>
                        <p>
                            If you are a performer and you are flexible on the time slots in which you can perform, you can
                            initially make yourself available for all the time slots. Once a host schedules you for one of
                            their time slots, you may decide to remove the other slots from your preferences.
                        </p>
                        <br/>

                        <h5><strong>How does a matched host and performer cancel their match?</strong></h5>
                        <p>
                            If a host and performer have agreed to cancel their match, it is the host's responsibility
                            to un-schedule the performer's act from the time slot they previously agreed upon. This will
                            indicate to the Porchfest committee that a match has been cancelled, and will put the act back
                            on the list of performers looking for a match. The host should follow these steps to cancel
                            a match:
                        </p>
                        <ol>
                            <li>Login to the site (if they have not done so already).</li>
                            <li>Find the venue you want to unschedule an act from in the <Link to="/myvenues" reloadDocument="true">my venues</Link> page.</li>
                            <li>Click the "Slots / Schedule" button next to the venue name.</li>
                            <li>Unselect the act you want to unschedule from the slot you previously agreed upon.</li>
                            <li>Click the Save button at the bottom of the page.</li>
                        </ol>
                        <p>
                            If you have any trouble cancelling a match, please <Link to="/contact" reloadDocument="true">contact</Link> us and we will help you.
                        </p>
                        <br/>

                        <h5><strong>I am a host or a performer that cannot find a match. What can I do?</strong></h5>
                        <p>
                            Once the registration on our website closes, the Porchfest committee will review all
                            the remaining unmatched acts and venues. Depending on the number of remaining entities
                            and if time permits, the committee will attempt to reach out to the remaining owners to
                            see if matches can still be made. However, the committee cannot guarante that everyone who
                            registers will be matched.
                        </p>
                        <br/>

                        <h5><strong>What does a host provide/do?</strong></h5>
                        <p>
                            By registering on our site, a host agrees to:
                        </p>
                        <ul>
                            <li>
                                <strong>Provide a venue</strong> for one or more acts to perform on during one of the time slots
                                that the host makes available. The venue can be a porch or patio, a driveway or a
                                parking lot, with room to fit performers and their equipment. The venue should also
                                include an area for an audience, making sure it does not block sidewalks or driveways.
                            </li>
                            <li>
                                <strong>Coordinate the venue activities</strong>  on Porchfest day. You will be the
                                performer's go-to person, making sure acts end on time and handling any issues that come up.
                            </li>
                            <li>
                                <strong>Clean up </strong> after performances, using your own trash and recycling bins.
                            </li>
                            <li>
                                <strong>Keep neighbors in the loop</strong>. Please be a good neighbor and let
                                them now about your plan for Porchfest day to avoid any surprises.
                            </li>
                            <li>
                                <strong>Display a Porchfest lawn sign</strong> at your venue. We will provide signs
                                for you to use at your venue ahead of the event so you can let people know you will be
                                hosting.
                            </li>
                        </ul>
                        <br/>

                        <h5><strong>What does a performer provide/do?</strong></h5>
                        <p>
                            By registering on our site, a performer agrees to:
                        </p>
                        <ul>
                            <li>
                                <strong>Provide a performance</strong> consisting of a musical act, dance, or poetry.
                                The performer will provide a description of the performance on our site.
                            </li>
                            <li>
                                <strong>Stick to the program on Porchfest day</strong>. You are expected to perform within
                                the time slot that you agreed upon with the host, and be timely with respect to arrival
                                time, setup, etc.
                            </li>
                            <li>
                                <strong>Bring your own equipment</strong> to the venue. If you need electric power or
                                other accommodations, please make sure you mention that to potential venues that you're
                                looking to match with when you contact them.
                            </li>
                            <li>
                                <strong>Be respectful</strong> of the host, venue and audience. Please work with your
                                venue owner to ensure a smooth performance from setup to final clean up.
                            </li>
                        </ul>
                        <br/>

                        <h5><strong>What does the Porchfest committee provide/do?</strong></h5>
                        <p>
                            The Porchfest committee will:
                        </p>
                        <ul>
                            <li>Oversee the registration process on the site and help assess the viability of venues, if necessary.</li>
                            <li>Help with any issues related to matching.</li>
                            <li>Coordinate logistics for the Porchfest day.</li>
                            <li>Provide lawn signs for venues.</li>
                            <li>Publish the final Porchfest schedule on our site.</li>
                            <li>Announce rain date plans, if necessary.</li>
                        </ul>
                        <br/>

                        <h5><strong>When is the final Porchfest schedule published?</strong></h5>
                        <p>
                            The final Porchfest schedule is published at the end of May.
                        </p>
                        <br/>

                        <h5><strong>How do I login?</strong></h5>
                        <p>
                            After you register, you can use the email and password you created on our <Link to="/login" reloadDocument="true">login</Link> page.
                        </p>
                        <br/>

                        <h5><strong>I forgot my password, what should I do?</strong></h5>
                        <p>
                            If you forget the password you used to register, you can use our <Link to="/forgotpass" reloadDocument="true">forgot password</Link> page
                            to reset your password.
                        </p>
                        <br/>

                        <h5><strong>I am having trouble using the site, what should I do?</strong></h5>
                        <p>
                            If you have any trouble with the site, or have a general question, please use
                            our <Link to="/contact" reloadDocument="true">contact</Link> page to reach out to us.
                        </p>
                        <br/>

                        <h5><strong>I have photos and videos from Porchfest on my social media. What should I tag them with?</strong></h5>
                        <p>
                            We'd love it if you could tag your social media posts with <span className="badge text-bg-secondary font-monospace">#winporchfest2025</span>.
                        </p>
                        <br/>

                        {/*<p>TODO: Section for hosts: registration, add host(s)</p>*/}
                        {/*<p>TODO: Section for performers: registration, aff venue(s),</p>*/}
                        {/*<p>TODO: Section for matching: how hosts and performers find each other, matching process</p>*/}
                        {/*<p>TODO: Section for asking for help: when to do it</p>*/}
                        {/*<p>TODO: Section for post PF: tag us on social media with #winpf #winchesterporchfest</p>*/}
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default FAQ;
